import { ResetPasswordRequest } from "pages/Login/components/Forms/ResetPassword/ResetPassword";

import { FetchError, FetchSuccess, fetchV3, toJSON } from "..";

export const adminLogin = async (username: string, password: string) => {
  try {
    const response = await fetchV3(
      `admin-auth/login`,
      {
        method: "POST",
        body: JSON.stringify({
          username,
          password,
        }),
      },
      {
        page: "/",
        shouldSearchForPage: false,
      },
    );

    const result = await toJSON(response);

    if (result.token) {
      localStorage.setItem("role", "admin");
      localStorage.setItem("token", result.token);
    }

    if (result.reactapp_v) {
      localStorage.setItem("version", result.reactapp_v);
    }

    if (result.organization_env_v) {
      localStorage.setItem("env_version", result.organization_env_v);
    }

    if (result.setting_id) {
      localStorage.setItem("setting_id", result.setting_id);
    }

    return new FetchSuccess(response);
  } catch (res) {
    throw new FetchError(res);
  }
};

export const skipOTP = async () => {
  try {
    const response = await fetchV3(
      `admin-auth/otp-login-skp`,
      {
        method: "POST",
      },
      {
        page: "/",
        shouldSearchForPage: false,
      },
    );

    return new FetchSuccess(response);
  } catch (res) {
    throw new FetchError(res);
  }
};

export const resetPasswordApi = async ({
  password,
  password_confirmation,
}: ResetPasswordRequest) => {
  try {
    const response = await fetchV3(
      `admin-auth/reset-password`,
      {
        method: "POST",
        body: JSON.stringify({
          password,
          password_confirmation,
        }),
      },
      {
        page: "/",
        shouldSearchForPage: false,
      },
    );

    return new FetchSuccess(response);
  } catch (res) {
    throw new FetchError(res);
  }
};

export const getQrCode = async () => {
  try {
    const response = await fetchV3(`admin-auth/otp-setup-qr-code`, null, {
      page: "/",
      shouldSearchForPage: false,
    });

    return new FetchSuccess(response);
  } catch (res) {
    throw new FetchError(res);
  }
};

export const complete2FASetup = async () => {
  try {
    const response = await fetchV3(
      `admin-auth/otp-setup-login`,
      { method: "POST" },
      {
        page: "/",
        shouldSearchForPage: false,
      },
    );

    return new FetchSuccess(response);
  } catch (res) {
    throw new FetchError(res);
  }
};

export const confirmSetupOtpCode = async (code: string) => {
  try {
    const response = await fetchV3(
      `admin-auth/confirm-otp-setup-code`,
      {
        method: "POST",
        body: JSON.stringify({
          otp_confirmation_code: code,
        }),
      },
      {
        page: "/",
        shouldSearchForPage: false,
      },
    );

    return new FetchSuccess(response);
  } catch (res) {
    throw new FetchError(res);
  }
};

export const getRecoveryCodes = async (code: string) => {
  try {
    const response = await fetchV3(
      `admin-auth/recovery-codes`,
      {
        method: "POST",
        body: JSON.stringify({
          otp_confirmation_code: code,
        }),
      },
      {
        page: "/",
        shouldSearchForPage: false,
      },
    );

    return new FetchSuccess(response);
  } catch (res) {
    throw new FetchError(res);
  }
};

export const confirm2FACodeLogin = async (code: string) => {
  try {
    const response = await fetchV3(
      `admin-auth/otp-login`,
      {
        method: "POST",
        body: JSON.stringify({
          otp_confirmation_code: code,
        }),
      },
      {
        page: "/",
        shouldSearchForPage: false,
      },
    );

    return new FetchSuccess(response);
  } catch (res) {
    throw new FetchError(res);
  }
};
